/**
 * Модуль конфигов для слайдеров. Получаем объект, у которого ключ должен быть равен ключу
 * переданному в дата-атрибут data-slider-settings="mainPageSlider" обертки с классом js-slider
 * Таким образом можно управлять всеми конфигами в этом файле
 */
itsoftApp.createModule("slidersSettings", function () {
    // Локальные переменные
    const module = this;

    const Settings = {
        global: {
            slidesPerView: "auto",
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            centeredSlides: true,
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const sliderName = swiperContainer.getAttribute("data-slider-name");

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                }
            }
        },

        gallery: {
            slidesPerView: "auto",
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            autoplay: {
                delay: 3500,
                disableOnInteraction: false
            },
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const sliderName = swiperContainer.getAttribute("data-slider-name");

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                }
            },

            breakpoints: {
                // when window width is >= 320px
                320: {
                  slidesPerView: 1,
                  spaceBetween: 8
                },

                768: {
                  slidesPerView: 2,
                  spaceBetween: 9
                },
            }
        }
    }

    const getSettings = function (slidersSettingsKey) {
        return Settings[slidersSettingsKey];
    }

    module.getSettings = getSettings;
});